import React from 'react';
import { Navbar, Container } from 'react-bootstrap';
import { Helmet } from 'react-helmet';

import logo from '../asets/logo.jpg';
import sirimg from '../asets/SirMM1.jpg';
import mamimg from '../asets/BmamB.png';

import './About2.css';

const About2 = () => {
  return (
    <>
      <Helmet>
        <title>About Sahaj Public School - Best School in Shajapur, M.P.</title>
        <meta
          name="description"
          content="Learn about Sahaj Public School in Shajapur, Madhya Pradesh. Our vision, mission, faculty, and dedication towards holistic education."
        />
        <meta
          name="keywords"
          content="Sahaj Public School, About Sahaj Public School, School in Shajapur, Best School Madhya Pradesh, School Vision, School Mission"
        />
        <meta name="author" content="Sahaj Public School" />
        <meta name="robots" content="index, follow" />
      </Helmet>

      <Container className="my-5">
        <header>
          <h1>About Sahaj Public School</h1>
        </header>

        <section aria-labelledby="about-intro" className="mb-5">
          <div className="row align-items-center">
            <div className="col-md-6">
              <h2 id="about-intro" className="mb-3">Our Vision & Values</h2>
              <p>
                Welcome to Sahaj Public School, a nurturing community dedicated to shaping future leaders
                through holistic education and values-based learning.
              </p>
              <p>
                Our school's vision is to provide a platform where academic excellence meets character
                development, fostering a passion for lifelong learning.
              </p>
              <p>
                We uphold core values of <strong>Excellence, Integrity, Respect, Collaboration, and Innovation</strong>,
                instilling these virtues in every aspect of our educational journey.
              </p>
              <p>
                At Sahaj Public School, students explore a comprehensive curriculum with a strong focus on
                core subjects alongside co-curricular activities like sports, arts, and community service,
                nurturing their all-round development.
              </p>
              <p>
                Our modern infrastructure, experienced faculty, and emphasis on parental involvement ensure a
                conducive environment for learning and growth.
              </p>
              <p>
                Join us in shaping a brighter future, where every student is empowered to excel academically,
                socially, and emotionally.
              </p>
            </div>

            <div className="col-md-6 text-center">
              <img
                src={logo}
                alt="Sahaj Public School Logo"
                className="img-fluid rounded custom-img"
                style={{ width: '80%', border: '5px solid blue' }}
              />
            </div>
          </div>
        </section>

        {/* Director's Message */}
        <section
          aria-labelledby="director-message"
          className="my-5 bg-dark text-light p-4 rounded"
        >
          <Container>
            <div className="row align-items-center">
              <div className="col-md-6 text-center mb-4 mb-md-0">
                <img
                  src={mamimg}
                  alt="Mrs. Asha Jain, Director of Sahaj Public School"
                  className="img-fluid rounded custom-img"
                  style={{ width: '80%', border: '5px solid blue' }}
                />
              </div>

              <div className="col-md-6">
                <h2 id="director-message" className="mb-3">
                  Mrs. Asha Jain, Director of Sahaj Public School
                </h2>
                <p>
                  <strong>Director's Message</strong>
                </p>
                <p>
                  Sahaj Public School is not just a place of education; it’s a nurturing ground where dreams
                  take flight and characters are shaped. At Sahaj, we believe in holistic development, where
                  academics meet values, and every student is encouraged to excel.
                </p>
                <p>
                  Our journey began with a vision to create a learning environment that fosters creativity,
                  critical thinking, and compassion. We strive to instill a sense of responsibility and
                  integrity in our students, preparing them for life’s challenges.
                </p>
                <p>
                  Our dedicated team of educators is committed to providing quality education beyond textbooks,
                  focusing on practical learning and encouraging students to explore their interests and talents.
                </p>
                <p>
                  Sahaj Public School is a community where every individual is valued, respected, and supported.
                  We empower students to become leaders, innovators, and changemakers.
                </p>
                <p>
                  As the Director, I am proud of our achievements and excited for the journey ahead. Together,
                  let's inspire, learn, and grow.
                </p>
                <p><strong>Mrs. Asha Jain<br />Director</strong></p>
              </div>
            </div>
          </Container>
        </section>

        {/* Principal's Message */}
        <section
          aria-labelledby="principal-message"
          className="my-5 bg-dark text-light p-4 rounded"
        >
          <Container>
            <div className="row align-items-center flex-column-reverse flex-md-row">
              <div className="col-md-6">
                <h2 id="principal-message" className="mb-3">
                  Mr. Ankur Jain, Principal of Sahaj Public School
                </h2>
                <p>
                  <strong>Principal's Message</strong>
                </p>
                <p>
                  Welcome to Sahaj Public School, where we nurture young minds and shape future leaders.
                  Our school is a vibrant community where every child's potential is realized and celebrated.
                </p>
                <p>
                  We provide holistic education that goes beyond textbooks and exams. Our focus is on
                  developing well-rounded individuals excelling academically, socially, and emotionally.
                </p>
                <p>
                  We create a safe, nurturing environment where students feel valued and empowered to explore
                  their interests. Our faculty are mentors guiding students on their educational journey.
                </p>
                <p>
                  Our curriculum is comprehensive, challenging, and relevant to the changing world. We
                  encourage curiosity, creativity, and innovation.
                </p>
                <p>
                  Our core values of <strong>Excellence, Integrity, Respect, Collaboration, and Innovation</strong>
                  guide everything we do, shaping responsible and compassionate leaders.
                </p>
                <p>
                  Education at Sahaj Public School means holistic growth with co-curricular activities,
                  sports, arts, and community service to help every student find their passion.
                </p>
                <p>
                  Join us in this journey of discovery and transformation.
                </p>
                <p>
                  Warm regards,<br />
                  <strong>Mr. Ankur Jain<br />Principal</strong>
                </p>
              </div>

              <div className="col-md-6 text-center mb-4 mb-md-0">
                <img
                  src={sirimg}
                  alt="Mr. Ankur Jain, Principal of Sahaj Public School"
                  className="img-fluid rounded custom-img"
                  style={{ width: '80%', border: '5px solid blue' }}
                />
              </div>
            </div>
          </Container>
        </section>

        <Navbar bg="light" expand="lg" className="mt-5">
          <Container>
            <Navbar.Brand href="#">Sahaj Public School</Navbar.Brand>
          </Container>
        </Navbar>
      </Container>
    </>
  );
};

export default About2;
